import VideoBackground from 'vue-responsive-video-background-player';
import { initializeApp } from 'firebase/app';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
  faArrowLeft,
  faArrowUpFromBracket,
  faBars,
  faCaretDown,
  faCarSide,
  faChevronLeft,
  faPlane,
  faPlus,
  faRightFromBracket,
  faSignIn,
  faSpinner,
  faTrash,
  faUserPlus,
  faChevronRight,
  faMagnifyingGlass,
  faXmark,
  faCheck,
  faPencil,
  faFloppyDisk,
  faDownload,
  faArrowDownShortWide,
  faArrowDownWideShort,
} from '@fortawesome/free-solid-svg-icons';

import {
  faGoogle,
} from '@fortawesome/free-brands-svg-icons';

import {
  faCircleQuestion,
} from '@fortawesome/free-regular-svg-icons';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/tailwind.css';

import 'leaflet/dist/leaflet.css';

library.add(
  faArrowLeft,
  faSignIn,
  faGoogle,
  faUserPlus,
  faCaretDown,
  faPlus,
  faCarSide,
  faTrash,
  faPlane,
  faSpinner,
  faRightFromBracket,
  faBars,
  faArrowUpFromBracket,
  faChevronLeft,
  faChevronRight,
  faMagnifyingGlass,
  faXmark,
  faCheck,
  faCircleQuestion,
  faPencil,
  faFloppyDisk,
  faDownload,
  faArrowDownShortWide,
  faArrowDownWideShort,
);
Vue.component('font-awesome-icon', FontAwesomeIcon);

const firebaseConfig = {
  apiKey: 'AIzaSyAoI7EInPIqETk7uETWNnyZo8g4ZjVbOJA',
  authDomain: 'aab-household-ghg.firebaseapp.com',
  projectId: 'aab-household-ghg',
  storageBucket: 'aab-household-ghg.firebasestorage.app',
  messagingSenderId: '692355561120',
  appId: '1:692355561120:web:6683823547abc9bc6b3bc5',
  measurementId: 'G-JMH2VNS7YV',
};
initializeApp(firebaseConfig);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

Vue.component('video-background', VideoBackground);
